module.exports = __webpack_public_path__ + "static/media/slide1.8bce7aef.webp";